import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  IconButton,
  Stack
} from '@mui/material';
import { Visibility, Edit, Delete, Add } from '@mui/icons-material';
import studioApi from '../../api/studioApi';
import { useNavigate } from 'react-router-dom';
import ConfirmDeleteModal from '../../components/ConfirmDeleteModal';

export default function StudiListPage() {
  const [studi, setStudi] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const navigate = useNavigate();
  const pageSize = 10;

  useEffect(() => fetchStudi(0), []);

  const fetchStudi = (page) => {
    studioApi.list({ page, size: pageSize })
      .then(r => {
        setStudi(r.data.content || []);
        setTotalPages(r.data.totalPages || 0);
        setPage(r.data.number || 0);
      })
      .catch(err => console.error(err));
  };

  const openDeleteDialog = (id) => {
    setSelectedId(id);
    setOpenDeleteModal(true);
  };
  const closeDeleteDialog = () => {
    setSelectedId(null);
    setOpenDeleteModal(false);
  };
  const confirmDelete = async () => {
    try { await studioApi.delete(selectedId); fetchStudi(page); }
    catch (err) { console.error(err); }
    closeDeleteDialog();
  };

  return (
    <Container>
    <Typography variant="h4" sx={{ mb: 2 }}>Studi</Typography>
      <Button
                variant="contained"
                sx={{ mb: 2 }}
                onClick={() => navigate('/studi/create')}
              >
                Inserisci Studio
              </Button>
      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button
            key={i}
            variant={i === page ? "contained" : "outlined"}
            onClick={() => fetchStudi(i)}
          >
            {i + 1}
          </Button>
        ))}
      </Stack>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Ragione Sociale</TableCell>
            <TableCell>Partita IVA</TableCell>
            <TableCell>Indirizzo</TableCell>
            <TableCell>Telefono</TableCell>
            <TableCell>Azioni</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {studi.map(s => (
            <TableRow key={s.id}>
              <TableCell>{s.ragionesociale}</TableCell>
              <TableCell>{s.partitaIVA}</TableCell>
              <TableCell>{s.indirizzo}</TableCell>
              <TableCell>{s.telefono}</TableCell>
              <TableCell>
                <Stack direction="row">
                  <IconButton color="primary" size="small" onClick={() => navigate(`/studi/${s.id}`)}><Visibility /></IconButton>
                  <IconButton color="secondary" size="small" onClick={() => navigate(`/studi/edit/${s.id}`)}><Edit /></IconButton>
                  <IconButton color="error" size="small" onClick={() => openDeleteDialog(s.id)}><Delete /></IconButton>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button
            key={i}
            variant={i === page ? "contained" : "outlined"}
            onClick={() => fetchStudi(i)}
          >
            {i + 1}
          </Button>
        ))}
      </Stack>

      <ConfirmDeleteModal
        open={openDeleteModal}
        onCancel={closeDeleteDialog}
        onConfirm={confirmDelete}
        message="Sei sicuro di voler eliminare questo studio?"
      />
    </Container>
  );
}